export const DISMISS_FREE_BANNER = 'DISMISS_FREE_BANNER';
export const DISMISS_SCHEDULE_BANNER = 'DISMISS_SCHEDULE_BANNER';
export const DISMISS_TRIAL_BANNER = 'DISMISS_TRIAL_BANNER';
export const DISMISS_DESTINATION_BANNER = 'DISMISS_DESTINATION_BANNER';
export const DISMISS_PRO_ACTIVATION_LIMIT_BANNER = 'DISMISS_PRO_ACTIVATION_LIMIT_BANNER';
export const SET_CATALOG_PREVIEW_BANNER_DISPLAY = 'SET_CATALOG_PREVIEW_BANNER_DISPLAY';
export const SET_SELECTED_TIMEZONE = 'SET_SELECTED_TIMEZONE';
export const SET_SIDEBAR_STATUS = 'SET_SIDEBAR_STATUS';
export const SET_STUDIO_RIGHT_PANEL_STATUS = 'SET_STUDIO_RIGHT_PANEL_STATUS';
